import { useEffect } from "react";

export default function useUnsavedChangesWarning(condition) {
  useEffect(() => {
    const beforeunloadHandler = (e) => {
      if (condition) {
        e.preventDefault();
        e.returnValue = true;
      }
    };
    window.addEventListener("beforeunload", beforeunloadHandler);
    return () => {
      window.removeEventListener("beforeunload", beforeunloadHandler);
    };
  }, [condition]);
}
